import { Container } from "./index.styled";
import InfoFieldComponent from "./info-field/InfoField.component";

export default function WorkspaceRequireComponent() {
    return (
        <Container>
            <InfoFieldComponent />
        </Container>
    )
}